// @ts-nocheck

module.exports = { VERSION: "1" };
